<template>
  <!-- 流程委托 -->
  <div class="processDelegation_index">
    <van-nav-bar :title="'流程委托'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 right-text="新增委托"
                 @click-right="addAgent"
                 :fixed="true" />
    <div class="content">
      <van-search v-model="searchTxt"
                  shape="round"
                  placeholder="请输入搜索关键词"
                  @input="onSearch" />
      <van-list v-model="loading"
                class="process_list"
                :finished="finished"
                :finished-text="$t('toEvaluated.evaluateTxt3')"
                @load="onLoad">
        <van-cell v-for="(item,key) in processList"
                  :key="key"
                  class="process_box">
          <div class="list_no">
            <div class="title">
              <img src="@/assets/img/examRecord_1.png"
                   alt="" />
              <span>{{item.formname}}</span>
            </div>
            <div class="btn_box">
              <van-button type="danger"
                          size="mini"
                          @click="operationPro(item,'delete')">删除</van-button>
              <van-button type="info"
                          size="mini"
                          @click="operationPro(item,'update')">修改</van-button>
            </div>
          </div>
          <van-cell-group>
            <van-field label="开始时间"
                       :value="item.bd"
                       readonly />
            <van-field label="结束时间"
                       :value="item.ed"
                       readonly />
            <van-field label="委托人"
                       :value="item.dp_empcode+'-'+item.dp_empname"
                       readonly />
            <van-field label="被委托人"
                       :value="item.ag_empcode+'-'+item.ag_empname+'-'+item.ag_deptname"
                       readonly />
          </van-cell-group>
        </van-cell>
      </van-list>
    </div>

    <!-- 流程委托弹窗 -->
    <van-popup v-model="showAgentForm"
               class="Agent_Form_pop"
               position="right"
               :style="{ width: '100%', height: '100%' }">
      <div class="popup_fuck_box">
        <van-nav-bar :title="agentTile"
                     left-arrow
                     @click-left="showAgentForm = false"
                     :fixed="true">
        </van-nav-bar>
        <div class="form_content">
          <van-cell-group>
            <van-field v-model="agForm.deputeusername"
                       class="requisite"
                       label="委托人用户名"
                       readonly
                       :disabled="editTag == 'update'"
                       :placeholder="$t('module.PleaseChoose')" />
            <van-field v-model="agForm.deputeEmp"
                       label="委托人工号"
                       disabled />
            <van-field v-model="agForm.deputeName"
                       label="委托人姓名"
                       disabled />
            <van-divider />
            <van-field v-model="agForm.formautoidlist"
                       label="委托流程"
                       :class="agForm.proxyAllProcesses?'':'requisite'"
                       readonly
                       :disabled="editTag == 'update'"
                       :placeholder="$t('module.PleaseChoose')"
                       @click="checkPopTree('process')" />
            <van-field v-if="editTag == 'add'"
                       name="checkbox"
                       label="代理所有流程">
              <template #input>
                <van-switch v-model="agForm.proxyAllProcesses"
                            size="20" />
              </template>
            </van-field>
            <van-field v-model="agForm.agentusername"
                       label="代理人用户名"
                       class="requisite"
                       readonly
                       :disabled="editTag == 'update'"
                       :placeholder="$t('module.PleaseChoose')"
                       @click="checkPopTree('user')" />
            <van-field v-model="agForm.agentEmp"
                       label="代理人工号"
                       disabled />
            <van-field v-model="agForm.agentName"
                       label="代理人姓名"
                       disabled />
            <van-divider />
            <van-field v-model="agForm.bd"
                       label="开始日期"
                       class="requisite"
                       :placeholder="$t('module.PleaseChoose')"
                       @click="checkDateTime('bd',agForm.bd)" />
            <van-field v-model="agForm.ed"
                       label="结束日期"
                       class="requisite"
                       :placeholder="$t('module.PleaseChoose')"
                       @click="checkDateTime('ed',agForm.ed)" />
            <van-field v-model="agForm.ag_reason"
                       rows="3"
                       autosize
                       label="代理原因"
                       type="textarea"
                       :placeholder="$t('module.PleaseEnter')" />
          </van-cell-group>
        </div>
        <div class="form_btns">
          <van-button type="info"
                      @click="saveAgent">{{$t('module.Save')}}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 选择树弹窗 -->
    <PopTree ref="AgentPopTreeNode"
             :whichTree="whichTree"
             :module="9907"
             :multiseltree="multiseltree"
             @treeSelectValEvent="treeSelectValEvent"></PopTree>

    <!-- 日期时间选择弹窗 -->
    <van-popup v-model="showDateTimePicker"
               position="bottom"
               round>
      <van-datetime-picker type="datetime"
                           :title="$t('module.SelectDateTime')"
                           v-model="pickDateTime"
                           :min-date="minDate"
                           :max-date="maxDate"
                           :formatter="formatter"
                           @confirm="onDateTimeConfirm"
                           @cancel="showDateTimePicker = false" />
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
import { getAgentList, deleteAgent, addAgent, saveAgentRecord } from '@api/workbench.js'
import { getUserInfoByEmpCode } from '@/api/wx.js'
import { parseTime, createGguid } from '@/utils'
import PopTree from '@components/PopTree/index.vue'
export default {
  components: {
    PopTree
  },
  data () {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    return {
      userInfo,
      loading: false,
      finished: false,
      searchTxt: '',
      initProcess: [],
      processList: [],
      editTag: '',
      // 表单
      showAgentForm: false,
      agentTile: '新增流程委托代理',
      agForm: {
        deputeusername: userInfo.username,
        deputeuserid: userInfo.userid,
        deputeEmp: userInfo.empcode,
        deputeName: userInfo.empname,
        formautoidlist: "",
        formautoidlistid: "",
        proxyAllProcesses: false,
        agentusername: "",
        agentuserid: "",
        agentEmp: "",
        agentName: "",
        bd: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
        ed: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
        ag_reason: ''
      },
      popTreeTag: '',
      multiseltree: false,
      whichTree: 'employee',
      showDateTimePicker: false,
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2121, 11, 31),
      pickDateTime: new Date(), // 日期时间
      dateTag: 'bd'
    }
  },
  computed: {
    btnAble () {
      if (
        this.agForm.deputeuserid != "" &&
        this.agForm.agentuserid != "" &&
        ((!this.agForm.proxyAllProcesses && this.agForm.formautoidlist != "") || this.agForm.proxyAllProcesses) &&
        this.agForm.bd != null &&
        this.agForm.ed != null
      )
      {
        return false;
      } else
      {
        return true;
      }
    }
  },
  watch: {
    showAgentForm (n) {
      if (!n)
      {
        this.agForm = {
          deputeusername: this.userInfo.username,
          deputeuserid: this.userInfo.userid,
          deputeEmp: this.userInfo.empcode,
          deputeName: this.userInfo.empname,
          formautoidlist: "",
          formautoidlistid: "",
          proxyAllProcesses: false,
          agentusername: "",
          agentuserid: "",
          agentEmp: "",
          agentName: "",
          bd: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
          ed: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
          ag_reason: ''
        }
      }
    }
  },
  created () {
    // this.getAgentListData()
  },
  methods: {
    // 保存流程
    saveAgent () {
      // 修改
      if (this.editTag == 'update')
      {
        if (this.agForm.bd == '' || this.agForm.ed == '')
        {
          Toast.fail('请填写必填项！')
          return
        }
        let params = {
          autoid: this.agForm.autoid,
          deputeuserid: this.agForm.deputeuserid,
          agentuserid: this.agForm.agentuserid,
          formautoid: this.agForm.formautoidlistid,
          bd: this.agForm.bd,
          ed: this.agForm.ed,
          ag_reason: this.agForm.ag_reason,
          username: this.userInfo.username
        }
        saveAgentRecord(params).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            Toast.success(this.$t('module.editSuc'))
            this.getAgentListData()
            this.showAgentForm = false
          }
        })

      } else
      {
        // 新增 
        if (this.btnAble)
        {
          Toast.fail('请填写必填项！')
          return
        }
        let params = {
          deputeuserid: this.agForm.deputeuserid,
          formautoidlist: this.agForm.proxyAllProcesses ? 0 : this.agForm.formautoidlistid,
          agentuserid: this.agForm.agentuserid,
          bd: this.agForm.bd,
          ed: this.agForm.ed,
          username: this.userInfo.username,
          ag_reason: this.agForm.ag_reason,
          is_fix_dept: false,
          deptautoidlist: ''
        };
        addAgent(params).then(res => {
          if (res.data[0].info)
          {
            Toast.fail(res.data[0].info);
          } else
          {
            Toast.success(this.$t('module.SaveSuc'))
            this.getAgentListData()
            this.showAgentForm = false
          }
        });
      }
    },
    // 日期时间选择回调
    onDateTimeConfirm (value) {
      const val = parseTime(value, '{y}-{m}-{d} {h}:{i}')
      if (this.dateTag == 'bd')
      {
        this.agForm.bd = val
      } else if (this.dateTag == 'ed')
      {
        this.agForm.ed = val
      }
      this.showDateTimePicker = false
    },
    formatter (type, val) {
      if (type === 'year')
      {
        return val + '年'
      }
      if (type === 'month')
      {
        return val + '月'
      }
      if (type === 'day')
      {
        return val + '日'
      }
      return val
    },
    // 选择日期
    checkDateTime (tag, date) {
      this.pickDateTime = new Date(date)
      this.dateTag = tag
      this.showDateTimePicker = true
    },
    // 选择树回调
    treeSelectValEvent (data) {
      if (this.popTreeTag == 'process')
      {
        let idList = data.map(item => { return item.formautoid; }).join(",");
        let nameList = data.map(item => { return item.keyname; }).join(",");
        this.agForm.formautoidlist = nameList;
        this.agForm.formautoidlistid = idList;
      } else if (this.popTreeTag == 'user')
      {
        getUserInfoByEmpCode({
          empcode: data.empcode
        }).then(res => {
          if (res.data.length > 0)
          {
            const user = res.data[0]
            this.agForm.agentusername = user.username;
            this.agForm.agentuserid = user.userid;
            this.agForm.agentEmp = user.empcode;
            this.agForm.agentName = user.empname;
          }
        })
      }
    },
    // 选择弹出树
    checkPopTree (tag) {
      this.popTreeTag = tag
      // 修改时不能改
      if (this.editTag == 'update')
      {
        return
      }
      if (tag == 'process')
      {
        this.whichTree = ''
        this.multiseltree = true
        this.$refs.AgentPopTreeNode.module = 9907
        this.$refs.AgentPopTreeNode.treename = 'workflowtree'
        this.$refs.AgentPopTreeNode.editstate = 2
        this.$refs.AgentPopTreeNode.showEmpTreePop('流程')
      } else if (tag == 'user')
      {
        this.whichTree = 'employee'
        this.multiseltree = false
        this.$refs.AgentPopTreeNode.module = 9907
        this.$refs.AgentPopTreeNode.treename = 'emptree'
        this.$refs.AgentPopTreeNode.editstate = 2
        this.$refs.AgentPopTreeNode.showEmpTreePop('代理人')
      }
    },
    // 修改/删除
    operationPro (item, tag) {
      if (tag == 'delete')
      {
        // 删除
        Dialog.confirm({
          title: this.$t('module.systemhint'),
          message: this.$t('module.sureToDelete'),
        }).then(() => {
          deleteAgent({ autoidlist: item.autoid, username: this.userInfo.username }).then(res => {
            if (res.data[0].info)
            {
              Toast.fail(res.data[0].info);
            } else
            {
              Toast.success(this.$t('module.DelSuc'))
              this.getAgentListData()
            }
          })
        }).catch(() => {
          // on cancel
        });
      } else
      {
        // 修改
        this.editTag = 'update'
        this.agentTile = '编辑流程委托代理'
        this.agForm.autoid = item.autoid
        this.agForm.agentusername = item.ag_username;
        this.agForm.agentuserid = item.agentuserid;
        this.agForm.agentEmp = item.ag_empcode;
        this.agForm.agentName = item.ag_empname;
        this.agForm.deputeusername = item.dp_username
        this.agForm.deputeuserid = item.deputeuserid
        this.agForm.deputeEmp = item.dp_empcode
        this.agForm.deputeName = item.dp_empname
        this.agForm.bd = item.bd
        this.agForm.ed = item.ed
        this.agForm.formautoidlist = item.formname
        this.agForm.formautoidlistid = item.formautoid
        this.agForm.ag_reason = item.ag_reason
        // console.log(this.agForm, 'this.agForm', item);
        this.showAgentForm = true
      }
    },
    // 查询
    onLoad () {
      this.getAgentListData()
    },
    // 获取流程委托信息
    getAgentListData () {
      this.loading = true
      getAgentList({
        userid: this.userInfo.userid,
        username: this.userInfo.username,
        usedate: false,
        bd: parseTime(new Date(), '{y}-{m}-{d}'),
        ed: parseTime(new Date(), '{y}-{m}-{d}'),
        dp_username: '',
        ag_username: '',
        formname: ''
      }).then(res => {
        this.initProcess = JSON.parse(JSON.stringify(res.data))
        this.processList = res.data
        this.loading = false;
        this.finished = true;
      })
    },
    // 新增委托
    addAgent () {
      this.editTag = 'add'
      this.agentTile = '新增流程委托代理'
      this.showAgentForm = true
    },
    // 搜索
    onSearch () {
      if (this.searchTxt)
      {
        this.processList = this.initProcess.filter(
          item =>
            item.formname.indexOf(this.searchTxt) > -1
        )
      } else
      {
        this.processList = this.initProcess
      }
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    }
  }

}
</script>

<style lang="less" scoped>
.processDelegation_index {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      font-size: 28px;
      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-search {
      height: 112px;
    }
    .process_list {
      // margin-top: 20px;
      height: calc(100% - 112px);
      overflow-y: auto;
      .process_box {
        padding: 0 !important;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
        margin-bottom: 30px;
        .van-cell__value {
          overflow: visible;
          .list_no {
            padding: 0 20px;
            // margin-bottom: 20px;
            line-height: 64px;
            word-break: break-all;
            background: linear-gradient(
              90deg,
              rgba(25, 137, 250, 0) 0%,
              rgba(25, 137, 250, 0.5) 0%,
              rgba(25, 137, 250, 0) 100%
            );
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
              display: flex;
              align-items: center;
              font-size: 28px;
              color: #333333;
              img {
                margin-right: 6px;
              }
            }
            .btn_box {
              display: flex;
              align-items: center;
              .van-button {
                padding: 0 20px;
              }
            }
          }
          .van-cell-group {
            padding: 0 20px;
          }
        }
      }
    }
  }

  // 流程委托弹窗
  .Agent_Form_pop {
    height: 100vh;
    width: 100%;
    overflow: hidden;
    .popup_fuck_box {
      width: 100%;
      height: 100%;
      position: relative;
      .van-nav-bar {
        background: #2b8df0;
        position: inherit;
        /deep/ .van-nav-bar__left {
          .van-icon {
            color: #fff;
          }
        }
        /deep/.van-nav-bar__title {
          color: #fff;
          font-size: 36px;
          font-family: Source Han Sans CN;
        }
      }
      .form_content {
        overflow-y: auto;
        position: relative;
        // margin-top: 1.22667rem;
        height: calc(100% - 192px);
        background-color: #f6f6f6;
        .van-cell-group {
          .van-cell::after {
            border-bottom: 0;
          }
          /deep/.requisite {
            .van-field__label {
              color: red;
            }
          }
          .van-divider {
            padding: 0 30px;
          }
        }
      }
      .form_btns {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-button {
          width: 90%;
          height: 80%;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>